module.exports = __webpack_public_path__ + "static/img/btn_drak.aeea3fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn_drak.png
// module id = BsiQ
// module chunks = 1